import React, { useEffect, useState } from "react";
import { useVoiceRecorder } from "../../hooks/useVoiceRecorder";
import styles from "./voiceMessageButton.module.css";
import Tooltip from "../tooltip/tooltip";

interface VoiceMessageButtonProps {
  onSend: (audioBlob: Blob) => void;
}

const VoiceMessageButton: React.FC<VoiceMessageButtonProps> = ({ onSend }) => {
  const {
    isRecording,
    audioURL,
    startRecording,
    stopRecording,
    deleteRecord,
    stopUsingMicrophone,
  } = useVoiceRecorder();

  const [showTooltip, setShowTooltip] = useState(false);
  const [timer, setTimer] = useState(0);

  let interval: NodeJS.Timeout;
  useEffect(() => {
    if (isRecording) {
      interval = setInterval(() => {
        setTimer((prev) => prev + 1); // Increment the timer every second
      }, 1000);
    } else if (interval) {
      clearInterval(interval);
    }
    return () => clearInterval(interval); // Cleanup the interval on unmount
  }, [isRecording]);

  const handleSendAudio = async () => {
    if (audioURL) {
      const response = await fetch(audioURL);
      const blob = await response.blob();
      onSend(blob);
      stopUsingMicrophone();
    }
  };

  const handleStopRecording = () => {
    stopRecording();
    setTimer(0);
  };

  return (
    <div className={styles.voiceMessageContainer}>
      <button
        type="button"
        className={`${styles.button} ${
          isRecording ? styles.button_type_stop : styles.button_type_record
        }`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={isRecording ? handleStopRecording : startRecording}
        // disabled={audioURL !== ""} // Disable button when audio is ready to be sent
      >
        <Tooltip isShown={showTooltip} position={"center"}>
          {isRecording ? "עצור הקלטה" : "הקלט הודעה קולית"}
        </Tooltip>
      </button>
      {isRecording && (
        <div className={styles.timer}>
          <span>{`${Math.floor(timer / 60)}:${timer % 60 < 10 ? "0" : ""}${
            timer % 60
          }`}</span>
        </div>
      )}
      {audioURL && (
        <>
          {/*<div className={styles.audioPreview}>*/}
          <audio className={styles.audio} controls src={audioURL} />
          <button
            type="button"
            className={`${styles.button} ${styles.button_type_delete}`}
            onClick={deleteRecord}
          />
          <button
            type="button"
            className={`${styles.button} ${styles.button_type_send}`}
            onClick={handleSendAudio}
          />
          {/*</div>*/}
        </>
      )}
    </div>
  );
};

export default VoiceMessageButton;
